import { Button } from 'common-front/src/designSystem/components/button';
import {
    closeOtherDropdowns,
    Dropdown
} from 'common-front/src/designSystem/components/dropdown/dropdown';
import { ItemIcon } from 'common-front/src/designSystem/components/dropdown/item';
import { Menu } from 'common-front/src/designSystem/components/dropdown/menu';
import { Trigger } from 'common-front/src/designSystem/components/dropdown/trigger';
import { Modal } from 'common-front/src/designSystem/components/modal/modal';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { SegmentHeader } from 'common-front/src/segments/segmentHeader';
import { useSegmentsContext } from 'common-front/src/segments/segmentsContext';
import { ExportFormat } from 'common/src/generated/types';
import { isNonEmptyArray } from 'common/src/util/array';
import { HeaventPaths } from 'common/src/util/paths/heaventPaths';
import * as React from 'react';
import {
    useDelegationsExportMutation,
    useParentDelegationsQuery
} from '../../generated/graphqlHooks';
import { useNotificationContext } from '../../notifications/notificationContext';
import { FileExportModal } from '../../volunteers/export/fileExportModal';
import { CreateDelegationModal } from './createDelegationModal';

export const DelegationsHeader = () => {
    const {
        params: { organizationId, eventId },
        translate
    } = useHeavent();
    const { segment, columns } = useSegmentsContext();
    const { data } = useParentDelegationsQuery({ organizationId });
    const { mutate: delegationsExport } = useDelegationsExportMutation();
    const [isFileExportOpen, setFileExportOpen] = React.useState(false);
    const hasParentDelegations = isNonEmptyArray(data.organization?.delegations.nodes);
    const { checkExport } = useNotificationContext();
    const requestExport = async (format: ExportFormat) => {
        const { jobId } = await delegationsExport({
            organizationId,
            eventId,
            segmentId: segment.id,
            format,
            columns
        });
        checkExport(organizationId, eventId, jobId);
    };

    return (
        <SegmentHeader>
            {hasParentDelegations ? (
                <Modal.Root>
                    <Modal.Trigger>
                        <Button>{translate('cr_er_une_d_l_g_23035')}</Button>
                    </Modal.Trigger>

                    <CreateDelegationModal
                        parentDelegations={data.organization.delegations.nodes}
                    />
                </Modal.Root>
            ) : (
                <Button to={HeaventPaths.CREATE_DELEGATION(organizationId, eventId)}>
                    {translate('cr_er_une_d_l_g_23035')}
                </Button>
            )}

            <Dropdown>
                <Trigger>
                    <Button color="white" leftIcon="ellipsis-vertical" />
                </Trigger>

                <Menu placement="bottom-end">
                    <ItemIcon
                        icon="file-import"
                        to={HeaventPaths.EVENT_DELEGATIONS_IMPORT(organizationId, eventId)}
                        onClick={(e) => closeOtherDropdowns(e.target)}
                    >
                        {translate('importer_des_d_05454')}
                    </ItemIcon>

                    <ItemIcon
                        icon="file-xls"
                        onClick={(e) => {
                            closeOtherDropdowns(e.target);

                            setFileExportOpen(true);
                        }}
                    >
                        {translate('exporter_en_exc_51862')}
                    </ItemIcon>
                </Menu>
            </Dropdown>

            <FileExportModal
                isOpen={isFileExportOpen}
                requestExport={requestExport}
                showIncludeFiles={false}
                onClose={() => {
                    setFileExportOpen(false);
                }}
            />
        </SegmentHeader>
    );
};
